import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';

const Settings = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
          Support Settings
        </h1>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
        <div className="flex flex-col items-center justify-center py-12">
          <Icons.Settings className="w-16 h-16 text-gray-400 mb-4" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Support Configuration</h3>
          <p className="text-gray-600 text-center max-w-md">
            Configure support team settings and preferences.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default Settings;
